import { render, staticRenderFns } from "./DamayanSD.vue?vue&type=template&id=5aa4267a&"
import script from "./DamayanSD.vue?vue&type=script&lang=js&"
export * from "./DamayanSD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports